<template>
    <v-dialog
        v-model="dialogShow"
        @confirm="remindMobileEvent"
        title="请先绑定手机号再操作"
        kind="confirm"
    >
        <span
            slot="confirm-text"
        >去绑定</span>
    </v-dialog>
</template>

<script>

export default {
    name: 'BindMobileNumber',
    data() {
        return {
            dialogShow: false,
        };
    },

    mounted() {},
    methods: {
        remindMobileEvent() {
            // window.open('/mng/account/profile');
            window.location.replace('/mng/account/profile')
        },
    },
};
</script>
